export default [
  // 新着商品
  {
    path: '/ja',
    name: 'ja',
    hidden: true,
    meta: {
      name: '新着商品',
      auth: false,
      icon: 'el-icon-s-shop',
    },
    component: resolve => require(['@/views/index/index.vue'], resolve),
    children: [{
      path: '/',
      name: '',
      meta: {
        name: '',
        auth: false,
        icon: ''
      },
      component: resolve => require(['@/views/lista/index.vue'], resolve),
    }, {
      path: 'search',
      name: '',
      meta: {
        name: '',
        auth: false,
        icon: ''
      },
      component: resolve => require(['@/views/lista/search.vue'], resolve),
    }, {
      path: 'commodityDetails',
      name: '',
      meta: {
        name: '',
        auth: false,
        icon: ''
      },
      component: resolve => require(['@/views/lista/commodityDetails.vue'], resolve),
    }]
  },
  // お知らせ
  {
    path: '/jb',
    name: 'jb',
    hidden: true,
    meta: {
      name: 'お知らせ',
      auth: false,
      icon: 'el-icon-s-shop',
    },
    component: resolve => require(['@/views/listb/index.vue'], resolve),
    children: [{
      path: '/',
      name: '',
      meta: {
        name: '',
        auth: false,
        icon: ''
      },
      component: resolve => require(['@/views/listb/homePage.vue'], resolve),
    }, {
      path: 'newsDetails',
      name: '',
      meta: {
        name: '',
        auth: false,
        icon: ''
      },
      component: resolve => require(['@/views/listb/newsDetail.vue'], resolve),
    }]
  },
  // 会社概要
  {
    path: '/jc',
    name: 'jc',
    hidden: true,
    meta: {
      name: '会社概要',
      auth: false,
      icon: 'el-icon-s-shop',
    },
    component: resolve => require(['@/views/listc/index.vue'], resolve),
    children: []
  },
  // 商品シリーズ一覧
  {
    path: '/jd',
    name: 'jd',
    hidden: true,
    meta: {
      name: '商品シリーズ一覧',
      auth: false,
      icon: 'el-icon-s-shop',
    },
    component: resolve => require(['@/views/listd/index.vue'], resolve),
    children: []
  },
  // プライバシーポリシー
  {
    path: '/jg',
    name: 'jg',
    hidden: true,
    meta: {
      name: 'プライバシーポリシー',
      auth: false,
      icon: 'el-icon-s-shop',
    },
    component: resolve => require(['@/views/listg/index.vue'], resolve),
    children: []
  },
  // お問い合わせ
  {
    path: '/jf',
    name: 'jf',
    hidden: true,
    meta: {
      name: 'お問い合わせ',
      auth: false,
      icon: 'el-icon-s-shop',
    },
    component: resolve => require(['@/views/listf/index.vue'], resolve),
    children: []
  },
]



// WEBPACK FOOTER //
// ./src/router/silderPath.js